import gridNames from "common/gridNames";
import foxGridReducer from "FoxReact/FoxGrid/reducer";

const administrationInvoices = foxGridReducer(gridNames.administrationInvoices);

export default administrationInvoices;
